/**
 * Slider Init
 */


if ('loading' === document.readyState) {
    // The DOM has not yet been loaded.
    document.addEventListener('DOMContentLoaded', sliderInit);
} else {
    // The DOM has already been loaded.
    sliderInit();
}

function sliderInit() {
    window.sliders = [];
    for (const sliderContainer of document.querySelectorAll('.swiper')) {
        for (const slide of sliderContainer.querySelectorAll('.swiper-wrapper > *')) {
            slide.classList.add('swiper-slide');
        }
        const dataSwiper = JSON.parse(sliderContainer.dataset['swiper']);
        const extraOptions = {
            speed: 1000,
            slidesPerView: 1,
        }
        const options = {
            ...extraOptions,
            ...dataSwiper
        }
        const slider = new Swiper(sliderContainer, options);
        window.sliders.push(slider);
    }
}